import type SVGType from 'types/svg.types';

const PegIconOutline: SVGType = (props) => (
  <svg
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0142 19.7395L8.98811 16.9204C8.79922 16.4014 9.0668 15.8276 9.58578 15.6387L10.5255 15.2967C10.5255 15.2967 9.41391 12.2427 12.4679 11.1311L11.7839 9.25171C11.7839 9.25171 13.5777 8.33275 14.3473 10.4471L17.4013 9.33549C19.4772 8.57992 21.7726 9.65027 22.5281 11.7262L23.3832 14.0754C24.1388 16.1514 23.0684 18.4467 20.9925 19.2023L15.1194 21.3399C13.0051 22.1095 12.2356 19.9951 12.2356 19.9951L11.2959 20.3371C10.7769 20.526 10.2031 20.2585 10.0142 19.7395Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.39 14.954C14.4844 15.2135 14.3507 15.5004 14.0912 15.5949C13.8317 15.6893 13.5448 15.5555 13.4503 15.296C13.3559 15.0365 13.4897 14.7496 13.7491 14.6552C14.0086 14.5607 14.2956 14.6945 14.39 14.954Z"
      stroke="currentColor"
    />
    <path
      d="M14.9688 21.6604L15.5673 23.3049"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0781 19.4373L21.6767 21.0817"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PegIconOutline;
